
import { mapState } from 'vuex'
import riskWarning from '@/components/company/head/riskWarning.vue'
import dealerTisk from '@/components/company/head/dealerTisk.vue'
import qrCode from '~/components/j/qrCode.vue'
import Companyinfoh5 from '~/components/company/companyinfoh5.vue'
export default {
  components: {
    'risk-warning': riskWarning,
    'dealer-tisk': dealerTisk,
    Companyinfoh5,
    'qr-code': qrCode
  },
  props: {
    main: {
      type: Object,
      default: () => {}
    },
    companytips: {
      type: Object,
      default: () => {}
    },
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ourl: '',
      returnurl: '',
      tiskshow: false,
      tipstype: '',
      Collect: this.isCollect,
      auther_wx_show: false,
      shareShow: false,
      companyindex: 0,
      wtype: 5,
      updateTimeClass: '',
      allWebsiteshow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      contentcookie: 'contentcookie'
    }),
    langtype() {
      // 长短语言类型0短语言1长语言
      let lang = ''
      if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh-hk' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh') lang = '0'
      else lang = '1'
      return lang
    },
    list1() {
      const arr = []

      if (this.main.countryName) {
        // 注册国
        arr.push({
          name: this.$t('54884'),
          icon: 'icon-a-Fram12',
          type: '1',
          val: this.main.countryName
        })
      }

      if (this.main.registrationNumber) {
        // 注册编号
        arr.push({
          name: this.$t('54789'),
          icon: 'icon-archive-book',
          type: '1',
          val: this.main.registrationNumber
        })
      }

      if (this.main.classificationCompanyTypeName) {
        // 企业类型
        arr.push({
          name: this.$t('54882'),
          icon: 'icon-building',
          type: '1',
          val: this.main.classificationCompanyTypeName
        })
      }

      this.main?.invests?.forEach((item) => {
        if (item.key == 0) {
          // 官方QQ
          arr.push({
            name: this.$t('22347'),
            icon: 'icon-Frame30',
            type: '2',
            val: item.values
          })
        } else if (item.key == 1) {
          // 客服电话
          arr.push({
            name: this.$t('20827'),
            icon: 'icon-a-Phone-calldianhuahujiao',
            type: '2',
            val: item.values
          })
        } else if (item.key == 2) {
          // Facebook
          arr.push({
            name: 'Facebook',
            icon: 'icon-Facebook',
            type: '2',
            val: item.values
          })
        } else if (item.key == 3) {
          // 客服邮箱
          arr.push({
            name: this.$t('22093'),
            icon: 'icon-sms2',
            type: '2',
            val: item.values
          })
        } else if (item.key == 5) {
          // X
          arr.push({
            name: 'X',
            icon: 'icon-X',
            type: '2',
            val: item.values
          })
        } else if (item.key == 6) {
          // 官方WeChat
          arr.push({
            name: this.$t('54889'),
            icon: 'icon-weixingongzhonghao',
            type: '2',
            val: item.values
          })
        } else if (item.key == 7) {
          // Instagram
          arr.push({
            name: 'Instagram',
            icon: 'icon-Instagram',
            type: '2',
            val: item.values
          })
        } else if (item.key == 8) {
          // Youtube
          arr.push({
            name: 'Youtube',
            icon: 'icon-Youtube',
            type: '2',
            val: item.values
          })
        } else if (item.key == 9) {
          // Linkedin
          arr.push({
            name: 'Linkedin',
            icon: 'icon-LinkedIn',
            type: '2',
            val: item.values
          })
        } else if (item.key == 10) {
          // WhatsApp
          arr.push({
            name: 'WhatsApp',
            icon: 'icon-Frame31',
            type: '2',
            val: item.values
          })
        }
      })
      if (arr?.length < 3) {
        const arr1 = [
          {
            name: this.$t('54884'),
            icon: 'icon-a-Fram12',
            type: '1',
            val: '--'
          },
          {
            name: this.$t('54789'),
            icon: 'icon-archive-book',
            type: '1',
            val: '--'
          },
          {
            name: this.$t('54882'),
            icon: 'icon-building',
            type: '1',
            val: '--'
          }
        ]
        arr1?.forEach((item) => {
          if (!arr.some((item1) => item1.icon === item.icon)) {
            arr.push(item)
          }
        })
      }
      return arr
    },
    listlxfs() {
      // 联系方式
      const arr = []
      if (this.main?.websiteList?.length > 0) {
        arr.push({
          name: this.$t('20852'),
          icon: 'icon-global-search',
          type: '9',
          val: this.main?.websiteList
        })
      }
      this.main?.invests?.forEach((item) => {
        if (item.key == 0) {
          // 官方QQ
          arr.push({
            name: this.$t('22347'),
            icon: 'icon-Frame30',
            type: '0',
            val: item.values
          })
        } else if (item.key == 1) {
          // 客服电话
          arr.push({
            name: this.$t('20827'),
            icon: 'icon-a-Phone-calldianhuahujiao',
            type: '2',
            val: item.values
          })
        } else if (item.key == 2) {
          // Facebook
          arr.push({
            name: 'Facebook',
            icon: 'icon-Facebook',
            type: '2',
            val: item.values
          })
        } else if (item.key == 3) {
          // 客服邮箱
          // arr.push({
          //   name: this.$t('22093'),
          //   icon: 'icon-sms2',
          //   type: '2',
          //   val: item.values
          // })
        } else if (item.key == 5) {
          // X
          arr.push({
            name: 'X',
            icon: 'icon-X',
            type: '2',
            val: item.values
          })
        } else if (item.key == 6) {
          // 官方WeChat
          arr.push({
            name: this.$t('54889'),
            icon: 'icon-weixingongzhonghao',
            type: '2',
            val: item.values
          })
        } else if (item.key == 7) {
          // Instagram
          arr.push({
            name: 'Instagram',
            icon: 'icon-Instagram',
            type: '2',
            val: item.values
          })
        } else if (item.key == 8) {
          // Youtube
          arr.push({
            name: 'Youtube',
            icon: 'icon-Youtube',
            type: '2',
            val: item.values
          })
        } else if (item.key == 9) {
          // Linkedin
          arr.push({
            name: 'Linkedin',
            icon: 'icon-LinkedIn',
            type: '2',
            val: item.values
          })
        } else if (item.key == 10) {
          // WhatsApp
          arr.push({
            name: 'WhatsApp',
            icon: 'icon-Frame31',
            type: '2',
            val: item.values
          })
        }
      })
      return arr
    }
  },
  watch: {
    contentcookie(newVal) {
      this.getcollecfn()
      // this.userId = this.$store.state.user.userId || ''
    }
  },
  mounted() {
    this.statistics(this.$store.state.allHost, 100, (item) => {})
    document.addEventListener(
      'click',
      () => {
        this.shareShow = false
        this.auther_wx_show = false
      },
      { passive: true }
    )
    this.getelewidth()
    console.log('公司头-main', this.main)
  },
  methods: {
    updateTime() {
      const that = this
      that.updateTimeClass = 'rotate-icon'
      setTimeout(function () {
        that.updateTimeClass = ''
      }, 500)
    },
    showAllWebsite() {
      this.allWebsiteshow = true
    },
    getcollecfn() {
      this.$api.common
        .CV3(
          {
            companyId: this.main.companyId, // CPD202412111418401041298563839
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'wikifxagg$company_detail'
          }
        )
        .then((res) => {
          console.log(res, 7778)
          this.Collect = res?.wikifxagg?.company_detail?.data?.companyExpand?.isCollect
        })
    },
    sharefn() {
      this.shareShow = true
    },
    showWx() {
      // 打开微信弹框
      // this.shareShow = false
      this.auther_wx_show = true
    },
    openwebfn(val) {
      // 打开官方网址
      this.ourl = val
      this.statistics(val, 101, (item) => {
        console.log(item, 8886)
        this.tipstype = String(item.type)
        this.totype(item)
      })
    },
    closetisk() {
      this.$nextTick(() => {
        this.tiskshow = false
      })
    },
    totype(typeval, type = 'sites') {
      // 跳转方式
      console.log(typeval, 789, this.companytips)
      this.returnurl = typeval?.url
      if (this.companytips?.title) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.tiskshow = true
          })
        }, 0)
      } else if (typeval.type == '0') {
        this.$refs.riskwarning.open()
      } else if (typeval.type == '1') {
        if (!typeval?.url?.includes('mobile/tradertips')) {
          this.closemodefn()
          // window.open(typeval?.url)
          if (this.$store.state.mobile) {
            // window.open(typeval?.url)
            setTimeout(() => {
              // 做定时器主要原因是苹果手机不这么做跳转不了，会被拦截
              const a = document.createElement('a')
              a.setAttribute('href', typeval?.url)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', typeval?.url)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=1')) {
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=0')) {
          this.$refs.riskwarning.open()
        }
      }
    },
    iframeif(val) {
      // iframe显示状态
      console.log(this.returnurl, 777)
      this.tiskshow = false
      if (val == '0') {
        this.$refs.riskwarning.open()
      } else if (val == '1') {
        if (!this.returnurl?.includes('mobile/tradertips')) {
          this.closemodefn()
          // window.open(this.returnurl)
          if (this.$store.state.mobile) {
            // window.open(this.returnurl)
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', this.returnurl)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', this.returnurl)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=1')) {
          if (this.$store.state.mobile) {
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=0')) {
          this.$refs.riskwarning.open()
        }
      }
    },
    statistics(url, spots, fn) {
      this.$api.common
        .CV3(
          {
            userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
            equipId: this.$Cookie.get('wiki-bfp'),
            platform: 3, // 平台类型
            apptype: 0, // 客户端类型
            ip: this.$store.state.userIp, // 用户ip
            ver: '0', // 版本
            equipinfo: '0', // 客户端类型
            country: this.$store.state.CountryCode, // 当前国家
            lang: this.$store.state.LanguageCode, // 当前语言
            type: 1, // 浏览类型
            code: this.main.companyId, // 交易商code
            spots, // 点位类型 100公司详情页，101官网
            url, // 对应网址
            jumpStatisticsUrl: this.$store.state.allHost,
            companyID: this.main.companyId
          },
          {
            Routes: 'statistics$company_count'
          }
        )
        .then((res) => {
          // console.log(res?.statistics?.company_count?.data, 'res')
          fn(res?.statistics?.company_count?.data)
        })
    },
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth())
        return 5 // >1200
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth())
        return 4 // >999
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth())
        return 3 // >799
      else return 3 // m端
    },
    numfn() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth())
        return 219 // >1200
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth())
        return 209 // >999
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth())
        return 218 // >799
      else return 2 // m端
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
    collectfn() {
      // 关注取消交易商
      if (!this.$store.state.user.userId) {
        this.$store.commit('loginClose', true)
        return
      }
      if (this.Collect) {
        this.usercollectiondeletefn()
      } else {
        this.usercollectionaddfn()
      }
    },
    usercollectionaddfn() {
      // 添加关注
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            traderCode: this.main.companyId,
            targetType: 7
          },
          {
            Routes: 'wikifx$usercollectionaddv2'
          }
        )
        .then((res) => {
          console.log(res, 7778, res?.wikifx?.usercollectionaddv2?.httpCode)
          if (res?.wikifx?.usercollectionaddv2?.success) {
            this.Collect = true
            this.$message({
              message: this.$t('36043'),
              type: 'success',
              duration: 1500
            })
          } else if (res?.wikifx?.usercollectionaddv2?.httpCode === 401) {
            console.log(333)
            this.$store.commit('loginverifyfn', true)
            this.userquit(() => {
              console.log(444)
              this.$store.commit('loginClose', true)
            })
          }
        })
    },
    usercollectiondeletefn() {
      // 删除收藏
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            traderCode: this.main.companyId,
            targetType: 7
          },
          {
            Routes: 'wikifx$usercollectiondeletev2'
          }
        )
        .then((res) => {
          console.log(res, 7778)
          if (res?.wikifx?.usercollectiondeletev2?.success) {
            this.Collect = false
            this.$message({
              message: this.$t('36044'),
              type: 'success',
              duration: 1500
            })
          } else if (res?.wikifx?.usercollectiondeletev2?.httpCode === 401) {
            console.log(333)
            this.$store.commit('loginverifyfn', true)
            this.userquit(() => {
              console.log(444)
              this.$store.commit('loginClose', true)
            })
          }
        })
    },
    prefn1() {
      // companyindex - 219
      const companylist = document.getElementById('companylist1')
      const companybox = document.getElementById('companybox1')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex == 0) return
      this.companyindex--
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    },
    nextfn1() {
      if (this?.list1?.length <= this.getelewidth()) return
      const companylist = document.getElementById('companylist1')
      const companybox = document.getElementById('companybox1')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex >= this?.list1?.length - this.getelewidth()) return
      this.companyindex++
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    },
    prefn2() {
      // companyindex - 219
      const companylist = document.getElementById('companylist2')
      const companybox = document.getElementById('companybox2')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex == 0) return
      this.companyindex--
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    },
    nextfn2() {
      if (this?.list1?.length <= this.getelewidth()) return
      const companylist = document.getElementById('companylist2')
      const companybox = document.getElementById('companybox2')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex >= this?.list1?.length - this.getelewidth()) return
      this.companyindex++
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    },
    prefn3() {
      // companyindex - 219
      const companylist = document.getElementById('companylist3')
      const companybox = document.getElementById('companybox3')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex == 0) return
      this.companyindex--
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    },
    nextfn3() {
      if (this?.list1?.length <= this.getelewidth()) return
      const companylist = document.getElementById('companylist3')
      const companybox = document.getElementById('companybox3')
      console.log(companylist.clientWidth, 2222, companybox.clientWidth)
      if (this.companyindex >= this?.list1?.length - this.getelewidth()) return
      this.companyindex++
      const left = this.companyindex * this.numfn()
      companylist.style.left = `-${left}px`
    }
  }
}
